import Pagination from "../pages/company/JobManagement/Components/Pagination";

interface ReusebleTableProps<T> {
  headers: string[];
  data: T[];
  renderRow: (row: T) => React.ReactNode;
  currentPage: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
  showPagination?: boolean;
}

function ReusebleTable<T extends { id: string }>({
  headers,
  data,
  renderRow,
  currentPage,
  pageSize,
  total,
  onPageChange,
  showPagination = true,
}: ReusebleTableProps<T>) {
  const totalPages = Math.ceil(total / pageSize);
  const startItem = total === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endItem = total === 0 ? 0 : Math.min(currentPage * pageSize, total);

  return (
    <div className="rounded-xl border bg-card shadow-sm overflow-x-auto bg-white">
      <table className="min-w-full border-collapse">
        <thead>
          <tr className="bg-gray-100 p-4">
            {headers.map((header, index) => (
              <th
                key={index}
                className="text-xs font-bold uppercase tracking-wider text-black-500 text-left p-4"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {(data ?? []).map((row) => (
            <tr key={row.id} className="border-b hover:bg-gray-50">
              {renderRow(row)}
            </tr>
          ))}
        </tbody>
      </table>
      {showPagination && totalPages > 1 && (
        <div className="flex flex-col gap-4 p-4 border-t bg-white">
          <div className="text-sm text-gray-600">
            Showing {startItem}-{endItem} of {total}
          </div>

          <div className="flex justify-center overflow-x-auto">
            <Pagination
              postsPerPage={pageSize}
              totalPosts={total}
              currentPage={currentPage}
              setCurrentPage={(page) => {
                const nextPage =
                  typeof page === "function" ? page(currentPage) : page;
                onPageChange(nextPage);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ReusebleTable;
